var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.flags),function(f){return _c('li',{key:f.id},[(f.subtype === 'flag')?[_c('i',{class:_vm.iconTypes[f.flag_type]}),_vm._v(" Mie: hvad her? :) ")]:void 0],2)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }